import { InventoryOutputModel } from 'src/app/models/inventory/inventory-output.model';
export class InventoryOutputDetailModel {
  inventoryOutputDetailId: number = 0;
  inventoryOutputId: number = 0;
  inventoryOutput: InventoryOutputModel | null = null;
  storeId: number = 0;
  articleId: number = 0;
  stock: number = 0;
  quantity: number = 0;
  unitPrice: number = 0;
  unitPriceSales: number = 0;
  inventoryOutputClass: number = 0;
  orderDetailId: number | null = null;
  internalOrderDetailId: number | null = null;
  createDate: Date = new Date();
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
  // solo se usa para devolver la cantidad pendiente
  quantityPending: number | null = null;
}